import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description StarFilled icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { StarFilled } from '@sravni/design-system-icons'
 *
 * <StarFilled />
 * ```
 */
var StarFilled = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "StarFilled", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M11.637 3.287a.4.4 0 0 1 .726 0L14.87 8.72a.4.4 0 0 0 .316.23l5.94.704a.4.4 0 0 1 .224.691l-4.391 4.061a.4.4 0 0 0-.121.372l1.166 5.867a.4.4 0 0 1-.588.427l-5.22-2.922a.4.4 0 0 0-.39 0l-5.22 2.922a.4.4 0 0 1-.588-.427l1.166-5.867a.4.4 0 0 0-.12-.372l-4.392-4.06a.4.4 0 0 1 .224-.692l5.94-.704a.4.4 0 0 0 .316-.23l2.506-5.432Z", strokeWidth: "1.25", stroke: "currentColor", fill: "currentColor" }))); });

export { StarFilled };
//# sourceMappingURL=StarFilled.js.map
